





















import { Component, Prop, Vue } from "vue-property-decorator";
import Muraflex from "@/components/Sliders/Muraflex.vue";

@Component({
  components: {
    Muraflex
  }
})
export default class Slider1Page extends Vue {
  data() {
    return {
      PageTitle: "Muraflex Slider"
    };
  }
  mounted() {}
}
